module.exports = __webpack_public_path__ + "img/beneficio4.77c74e92.svg";